import { cn } from "@cieda/djayma-ui";
import type { StockHistoryItem } from "@/lib/admin-api/stock";

interface StockHistoryRowProps {
  readonly item: StockHistoryItem;
}

const REASON_LABELS: Readonly<Record<string, string>> = {
  restock: "Réappro.",
  sale: "Vente",
  return: "Retour",
  adjustment: "Ajust.",
};

/**
 * Single row in the stock-history list. Shows delta, before→after, reason chip,
 * actor + department + time, and optional notes.
 */
export function StockHistoryRow({ item }: StockHistoryRowProps) {
  const isPositive = item.delta > 0;
  const timeStr = new Date(item.created_at).toLocaleString("fr-SN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="flex items-start gap-3 py-2 text-sm">
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span
            className={cn(
              "font-medium tabular-nums",
              isPositive ? "text-emerald-600" : "text-red-600",
            )}
          >
            {isPositive ? "+" : ""}
            {item.delta.toLocaleString("fr-SN")}
          </span>
          <span className="tabular-nums text-stone-500">
            {item.previous_stock.toLocaleString("fr-SN")} →{" "}
            {item.new_stock.toLocaleString("fr-SN")}
          </span>
          <span className="rounded-full bg-stone-100 px-1.5 py-0.5 text-xs text-stone-600">
            {REASON_LABELS[item.reason] ?? item.reason}
          </span>
        </div>
        <div className="mt-0.5 text-xs text-stone-400">
          {item.created_by.name} &middot; {item.created_by.department} &middot;{" "}
          {timeStr}
        </div>
        {item.notes && (
          <p className="mt-0.5 text-xs italic text-stone-400">{item.notes}</p>
        )}
      </div>
    </div>
  );
}
